import { useState, useEffect } from "react";

const BEACON_CHECK_DELAY_MS = 400;
const BEACON_RETRY_MS = 800;

/**
 * Detects whether the RepGuard browser extension is installed.
 * The extension injects a beacon script on RepCheck app origins that sets window.__REPGUARD_EXTENSION__.
 */
export function useRepGuardExtension() {
  const [installed, setInstalled] = useState(() => Boolean(typeof window !== "undefined" && window.__REPGUARD_EXTENSION__));

  useEffect(() => {
    if (installed) return;

    const check = () => {
      if (typeof window !== "undefined" && window.__REPGUARD_EXTENSION__) {
        setInstalled(true);
        return true;
      }
      return false;
    };

    const t1 = window.setTimeout(() => {
      if (check()) return;
      window.setTimeout(check, BEACON_RETRY_MS);
    }, BEACON_CHECK_DELAY_MS);

    return () => clearTimeout(t1);
  }, [installed]);

  return installed;
}
